<template>
  <div
    class="background-surface border--solid border--complementary-50 border-radius-8 padding-x-16 padding-y-24"
  >
    <div
      v-if="exercises.length || loading"
      class="color-complementary-400 margin-bottom-32"
    >
      {{ $lang.exercisePrerequisite }}
    </div>
    <LoadingWrapper :loading="loading">
      <template #loading>
        <Loading :count="3" />
      </template>
      <template #default>
        <div>
          <ul
            v-if="exercises.length"
            class="list-style--none padding-16 border--solid border--complementary-50 border-radius-8"
          >
            <li
              class="padding-bottom-16 margin-bottom-16 border--solid border--complementary-50 border--bottom"
              v-for="(exercise, index) in exercises"
              :key="`exercise-${index}`"
            >
              <ExercisePrerequisiteItem
                :item="exercise"
                :itemIndex="index"
                :permissions="permissions"
                @handleReload="getExercises"
              />
            </li>
          </ul>
          <div v-else class="flex-center flex-direction-column">
            <b-img-lazy
              class="width-181 margin-bottom-21"
              :src="generateEmptyImage"
            />
            <div
              class="color-complementary-300 font-size-14 font-weight-500 max-width-350 text-center"
            >
              {{ $lang.preExerciseAlertMessage }}
            </div>
          </div>
        </div>
      </template>
    </LoadingWrapper>
  </div>
</template>

<script>
import { LoadingWrapper } from "@/components/re-design";
import Loading from "./Loading.vue";
import ExercisePrerequisiteItem from "./ExercisePrerequisiteItem.vue";
import { computed, inject, onMounted, ref } from "vue";
import { generateConfig, generateError } from "@/shared/utils";
import { getCenterExecuteExercises } from "@/modules/kanoon/services";
export default {
  components: { LoadingWrapper, Loading, ExercisePrerequisiteItem },
  setup() {
    const centerExecuteData = inject("CENTER_EXECUTE_DATA");
    const permissions = ref([]);
    const loading = ref(false);
    const exercises = ref([]);
    const getExercises = async () => {
      try {
        loading.value = true;
        const { id: centerExecuteId } = centerExecuteData.value;
        const response = await getCenterExecuteExercises(centerExecuteId);
        const { items, getPermissions } = response;
        exercises.value = items;
        permissions.value = getPermissions;
      } catch (error) {
        generateError(error);
      } finally {
        loading.value = false;
      }
    };
    onMounted(() => getExercises());

    const generateEmptyImage = computed(() =>
      generateConfig([
        "images",
        "shared",
        "redesign",
        "empty",
        "exercisePrerequisite",
      ])
    );

    // return data to be used in template
    return {
      exercises,
      loading,
      permissions,
      getExercises,
      generateEmptyImage,
    };
  },
};
</script>
